// extracted by mini-css-extract-plugin
export default {"animation":"social-skeletons-SingleElementAnimation__animation--OPUUL","smoothLoadingAnimation":"social-skeletons-SingleElementAnimation__smoothLoadingAnimation--1ZVYo"};